import { render } from "./WarehouseProcureModal.vue?vue&type=template&id=240e7155&scoped=true"
import script from "./WarehouseProcureModal.vue?vue&type=script&lang=js"
export * from "./WarehouseProcureModal.vue?vue&type=script&lang=js"

import "./WarehouseProcureModal.vue?vue&type=style&index=0&id=240e7155&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240e7155"]])

export default __exports__